<form [formGroup]="apiKeyForm" (ngSubmit)="onOkClick()">
<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <mat-form-field class="full-width">
    <input formControlName="comment" matInput placeholder="Comment">
  </mat-form-field>

  <div style="margin-top: 10px;">
    API Key Consumer Type
    <div style="padding-left: 5px;">
      <mat-select placeholder="Consumer Type" formControlName="apiKeyType" [(value)]="apiKeyType">
        <mat-option [value]="0">Web Service</mat-option>
        <mat-option [value]="1">ATM-like</mat-option>
      </mat-select>

    </div>
  </div>


  <div style="margin-top: 10px;">
    Payment by partner
    <div style="padding-left: 5px;">
      <mat-checkbox formControlName="permissionPartnerPayment" matInput labelPosition="after">Invoice to partner</mat-checkbox><br />

    </div>
  </div>
  <div style="margin-top: 10px;">
    Payment by customer
    <div style="padding-left: 5px;">
      <mat-checkbox formControlName="permissionCreditCardPayment" matInput labelPosition="after">Credit card</mat-checkbox><br />
      <mat-checkbox formControlName="permissionSofortPayment" matInput labelPosition="after">Sofort-Überweisung</mat-checkbox><br />
      <mat-checkbox formControlName="permissionInvoicePayment" matInput labelPosition="after">Invoice to customer</mat-checkbox><br />

    </div>
  </div>

  <div style="margin-top: 20px;">
    <div>Misc. Functionalities</div>
      <mat-checkbox formControlName="permissionWalletBalance" matInput labelPosition="after">Get Wallet Balance</mat-checkbox><br />
      <mat-checkbox formControlName="permissionWalletLoad" matInput labelPosition="after">Do Wallet Load</mat-checkbox><br />
      <mat-checkbox formControlName="permissionCardUnload" matInput labelPosition="after">Unload card</mat-checkbox><br />
      <mat-checkbox formControlName="permissionQueryActiveCard" matInput labelPosition="after">Query active card</mat-checkbox><br />
      <mat-checkbox formControlName="permissionQueryLoadStatus" matInput labelPosition="after">Query load status</mat-checkbox><br />
      <mat-checkbox formControlName="permissionSetupWebhook" matInput labelPosition="after">Setup Webhook</mat-checkbox><br />
      <mat-checkbox formControlName="permissionUpdatePartnerCustomerId" matInput labelPosition="after">Update PartnerCustomerId</mat-checkbox><br />
  </div>

</div>
<div mat-dialog-actions align="end">
  <button type="button" mat-raised-button (click)="onCancelClick()" cdkFocusInitial color="">Cancel</button>

  <button mat-raised-button color="primary" type="submit" [disabled]="!apiKeyForm.valid || apiKeyForm.pristine">
    <mat-icon>done</mat-icon>
    <a>Confirm</a>
  </button>
</div>
</form>
